/**
 * flt_newsletter — entrée principale front TypeScript (→ views/js/flt_newsletter.js)
 * Charge dynamiquement le module JS du thème actif via data-theme.
 */

type ThemeSlug = 'menhir' | 'caribou-catalog' | 'caribou-store';

document.addEventListener('DOMContentLoaded', () => {
  loadTheme();
});

async function loadTheme(): Promise<void> {
  const wrapper = document.querySelector<HTMLElement>('.flt_newsletter-wrapper');
  const theme = (wrapper?.dataset.theme ?? 'menhir') as ThemeSlug;

  const themeModules: Record<ThemeSlug, () => Promise<{ init: () => void }>> = {
    'menhir':          () => import('./themes/menhir'),
    'caribou-catalog': () => import('./themes/caribou-catalog'),
    'caribou-store':   () => import('./themes/caribou-store'),
  };

  const loader = themeModules[theme] ?? themeModules['menhir'];
  const mod = await loader();
  mod.init();
}
